import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

export type LinkTarget = '_blank' | '_self';
export type LinkButtonSize = 'small' | 'medium' | 'large';
export type LinkButtonVariant = 'default' | 'inverted' | 'danger';

export interface LinkButtonProps {
  text: string;
  routerLink?: string;
  href?: string;
  target?: LinkTarget;
  size?: LinkButtonSize;
  variant?: LinkButtonVariant;
}

@Component({
  selector: 'iahoy-link-button',
  imports: [RouterModule],
  templateUrl: './link-button.component.html',
  styleUrl: './link-button.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.--disabled]': 'disabled()'
  }
})
export class LinkButtonComponent {
  text = input<string>('');
  size = input<LinkButtonSize>('medium');
  routerLink = input<string | undefined>(undefined);
  href = input<string | undefined>(undefined);
  target = input<LinkTarget>('_self');
  removeSpacing = input<boolean>(false);
  disabled = input<boolean>(false);
  variant = input<LinkButtonVariant>('default');
}
